import script from "./ConstellationFortune.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstellationFortune.vue?vue&type=script&setup=true&lang=js"

import "./ConstellationFortune.vue?vue&type=style&index=0&id=5a34d52c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a34d52c"]])

export default __exports__